import React, { Fragment, useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Delete from '@material-ui/icons/DeleteOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import CloseIcon from '@material-ui/icons/Close';
import MonetizationOn from '@material-ui/icons/MonetizationOn';
import Modal from '../../../../shared/components/Modal';
import ModalMat from '@material-ui/core/Modal';
import RepeatIcon from '@material-ui/icons/Repeat';
import { useEffect } from 'react';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import ImageIcon from '@material-ui/icons/Image';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStream } from "@fortawesome/free-solid-svg-icons";
import ZoomInIcon from '@material-ui/icons/ZoomIn';

const no_op = () => { }
const ReactTableActionsLedgerAccounts = ({ data, setAccountToUpdate = no_op, setOnUpdate = no_op, setOpenForm = no_op, getListAccountingAccount = no_op }) => {

    const [openAlert, setOpenAlert] = useState(false);
    const [modalAlert, setModalAlert] = useState({ message: '', color: '', title: '' });


    const onOkModal = () => {
        switch (modalAlert.color) {
            case "success":
                setOpenAlert(!openAlert);
                getListAccountingAccount();
                break;
            case "warning":
                deleteAccount();
                break;
            case "danger":
                setOpenAlert(!openAlert);
                break;
        }
    }

    const deleteAccount = async () => {
        let dataSend = {
            id_caja_contable: data.data.original.id_caja_contable
        }
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'cajas-contables/eliminar', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then(response => {
            if (response.status != 500 && response.status != 403 && response.status != 404) {
                setOpenAlert(true);
                setModalAlert({
                    message: "Cuenta eliminada",
                    color: 'success',
                    title: "Exito!"
                });
            }
            else {
                throw new Error("Ha ocurrido un error en el Servidor");
            }
        }).catch((error) => {
            setOpenAlert(true);
            setModalAlert({
                message: "Ha ocurrido un error en el Servidor",
                color: 'danger',
                title: "Error!"
            });
        });
    }

    const onToggleToEdit = (account) => {
        setAccountToUpdate(account);
        setOnUpdate(true);
        setOpenForm(true);
    }

    return (
        <Fragment>
            <td role="cell">

                <Tooltip title="Editar cuenta">
                    <IconButton
                        aria-label="edit"
                        // disabled={imageShow == undefined && imageShow == null ? true : false}
                        onClick={() => {
                            onToggleToEdit(data.data.original);
                        }}>
                        <EditOutlinedIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Eliminar cuenta">
                    <IconButton
                        aria-label="delete-account"
                        // disabled={imageShow == undefined && imageShow == null ? true : false}
                        onClick={() => {
                            setOpenAlert(true);
                            setModalAlert({
                                message: "¿Esta seguro que desea eliminar esta cuenta?",
                                color: 'warning',
                                title: "Advertencia!"
                            });
                        }}>
                        <Delete />
                    </IconButton>
                </Tooltip>
                {openAlert ?
                    <Modal
                        color={modalAlert.color}
                        title={modalAlert.title}
                        message={modalAlert.message}
                        modal={openAlert}
                        onOk={() => onOkModal()}
                        toggle={() => { setOpenAlert(!openAlert) }}
                    />
                    : null}
            </td>
        </Fragment>
    )
}

export default ReactTableActionsLedgerAccounts;